<template>
  <div class="project-analyze-box">
    <div class="left">
      <MultiLoadSelect
          v-model="projectValue"
          :options="projectList"
          :placeholder="'请输入项目号,例如：'+exampleProjectId"
          :input-height="250"
          :remote="true"
          :option-value-label="['projectsRow','projectId']"
          @change="handleProjectChange"
          @remote-search="remoteSearchProject"
          :multiple="false"
      />
    </div>
  </div>
</template>

<script>
import {searchProject, pickRecords} from '@/api/project'
import MultiLoadSelect from "@/components/MultiLoadSelect.vue";

export default {
  name: 'ProjectAnalyzeBox',
  components: {MultiLoadSelect},
  props: {
    value: Object,
    type: String,
    disabled: {
      type: Boolean,
      default: false
    },
    exampleProjectId: {
      type: String,
      default: 'MetaboXXXXXXXXXXXXXX'
    },
  },
  data() {
    return {
      projectValue: null,
      projectList: [],
      projectLoading: false,
      selectedProject: null,

      // 新增：防抖定时器
      searchTimer: null,
      // 新增：取消上一次请求控制器，终止旧请求
      searchAbortCtrl: null,
      // 防抖延迟时间，可自行调整 300~500ms
      debounceDelay: 350
    }
  },
  watch: {
    value: {
      handler(val) {
        const project = val && val.project
        if (!project) {
          this.selectedProject = null
          this.projectValue = null
          return
        }
        const newProjectId = project.projectsRow && project.projectsRow.projectId
        const currentProjectId = this.selectedProject && this.selectedProject.projectsRow
            ? this.selectedProject.projectsRow.projectId
            : ''
        if (newProjectId && newProjectId === currentProjectId) {
          return
        }
        this.selectedProject = project
        this.projectValue = project
        if (!this.projectList.some(p => p.projectsRow && p.projectsRow.projectId === newProjectId)) {
          this.projectList = [project, ...this.projectList]
        }
      },
      immediate: true
    }
  },
  methods: {
    // 远程搜索入口，触发防抖
    remoteSearchProject(keyword, resolve) {
      // 1. 清除上一次定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
      // 2. 终止还在pending的旧请求
      if (this.searchAbortCtrl) {
        this.searchAbortCtrl.abort()
        this.searchAbortCtrl = null
      }

      // 空关键词直接清空列表，不等待
      if (!keyword) {
        this.projectList = []
        resolve && resolve()
        return
      }

      // 3. 新建定时器，延迟执行搜索
      this.searchTimer = setTimeout(async () => {
        // 创建本次请求的控制器
        this.searchAbortCtrl = new AbortController()
        try {
          const res = await searchProject(
              { projectId: keyword, contractNumber: '' },
              this.type,
              // 把signal传给api，用于取消请求
              { signal: this.searchAbortCtrl.signal }
          )
          let list = pickRecords(res)
          // 保留已选中项目
          if (this.selectedProject && !list.some(p => p.projectsRow && p.projectsRow.projectId === this.selectedProject.projectsRow.projectId)) {
            list = [this.selectedProject, ...list]
          }
          this.projectList = list
        } catch (e) {
          // 主动abort的错误，直接忽略，不置空列表
          if (e.name !== 'AbortError') {
            this.projectList = []
          }
        } finally {
          resolve && resolve()
        }
      }, this.debounceDelay)
    },

    async handleProjectChange(project) {
      this.selectedProject = project || null
      this.emitOutput()
    },

    emitOutput() {
      this.$emit('input', {
        project: this.selectedProject,
      })
    }
  },
  beforeDestroy() {
    // 组件销毁，清理定时器和请求，防止内存泄漏
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
    if (this.searchAbortCtrl) {
      this.searchAbortCtrl.abort()
    }
  }
}
</script>

<style scoped>
.project-analyze-box {
  display: flex;
  align-items: center;
  gap: 30px;
}

.left {
  width: 100%;
  display: flex;
}

.right {
  width: 55%;
  display: flex;
}

.title {
  margin-right: 10px;
  white-space: nowrap;
}

.select {
  width: 100%;
  flex: 1;
}
</style>
